// src/services/appCheck.js
// Firebase App Check — reCAPTCHA Enterprise provider for web.
// Initialized once before any Firebase service call.
// Must run before initFirebase() to ensure all Firestore/Functions
// requests carry a valid App Check token.

let _initialized = false;

export async function initAppCheck() {
  if (_initialized) return;
  try {
    const { initializeApp, getApps } = await import('firebase/app');
    const { initializeAppCheck, ReCaptchaEnterpriseProvider } = await import('firebase/app-check');

    const FIREBASE = {
      apiKey:            import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain:        import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId:         import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket:     import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId:             import.meta.env.VITE_FIREBASE_APP_ID,
    };

    const app = getApps().length ? getApps()[0] : initializeApp(FIREBASE);

    initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider(
        import.meta.env.VITE_RECAPTCHA_SITE_KEY
      ),
      isTokenAutoRefreshEnabled: true,
    });

    _initialized = true;
    console.info('[AppCheck] Initialized');
  } catch (err) {
    // Non-fatal — app still works without App Check, just unprotected
    console.warn('[AppCheck] Init failed (non-fatal):', err.message);
  }
}
